// @flow
export default (value: ?boolean): boolean => value == null ? true : !!value
